// Add External Coordinator

import { Component } from '@angular/core';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-add-external-coordinator',
  templateUrl: './add-external-coordinator.component.html',
  styleUrls: ['./add-external-coordinator.component.scss']
})
export class AddExternalCoordinatorComponent {
  header = this.translate('Register External Coordinator');
  links: link[] = [
    { name: this.translate('Back'), icon: 'pi pi-angle-right', link: '/company' },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Register External Coordinator'),  link: '/add-external-coordinator', },
  ];
  stats: stat[] = [];


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

}
